/* --------------------------------------------------------------------------*/
/*                              FAQ Rich Snippets                            */
/* --------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function() {
  var buttons = document.querySelectorAll(".hd-content__faq--wrap");

  if (window.innerWidth < 992) {
    buttons.forEach(function(button) {
      button.addEventListener("click", function() {
        this.classList.toggle("hd-content__faq--wrap__active");
      });
    });
  }

  if (window.innerWidth > 991) {
    buttons.forEach(function(button) {
      button.classList.add("hd-content__faq--wrap__active");
    });
  }
});

  